import { InjectionToken, Provider } from '@angular/core';
import { environment } from '@environments/environment';
import { InvoicesApiService } from '../invoices-api.service';
import { InvoicesRepository } from '../invoices.repository';
import { InvoicesApiServiceMock } from '@mocks/invoices-api-mock.service';

export const HTTP_INVOICES_SERVICE = new InjectionToken<InvoicesRepository>('InvoicesRepository');

export const INVOICES_API_PROVIDER: Provider = {
    provide: HTTP_INVOICES_SERVICE,
    useClass: environment.useMocks && environment.useMocks.invoices ? InvoicesApiServiceMock : InvoicesApiService,
};
